import React, {useEffect, useState} from "react";
import {MdArrowDropDown, MdArrowDropUp, MdBarChart, MdOutlineCalendarToday,} from "react-icons/md";
import Card from "components/card";
import {lineChartOptionsMonthlyData, lineChartOptionsTotalSpent, lineChartRegisteredUsersData} from "variables/charts";
import LineChart from "components/charts/LineChart";
import useAsyncEffect from "use-async-effect";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import axios from "axios";
import {getLastCompleteMonthPeriod} from "utils/reportingPeriod";

const RegisteredUsersGraph = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [activatedUsersCount, setActivatedUsersCount] = useState([]);
    let [momUsersPercentage, setMomUsersPercentage] = useState(0)

    const [presentMonthCount, setPresentMonthCount] = useState([]);

    let [dataCount, setDataCount] = useState([]);
    let [options, setOptions] = useState([]);

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    const handleIncreaseDate = (currentDate) => {
        const newDate = moment(currentDate, 'DD-MM-YYYY').add(1, 'days');
        currentDate = newDate.format('DD-MM-YYYY')
        //console.log("CURRENT DATE: ", currentDate)
        return currentDate
    };

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const reportingPeriod = getLastCompleteMonthPeriod();
    const [LowerDate] = useState(reportingPeriod.startDate);
    const [UpperDate] = useState(reportingPeriod.endDate);

    function getMonthlyRegisteredUsersTrend() {
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "4") || (accesscontrollevel.toString() === "5")) {
            var chartLabels = [];
            var count = [];
            var url = CROMPTON_ANALYTICS_URL + "v1/user/UsersMonthly/" + formatDateForApi(LowerDate) + "/" + handleIncreaseDate(formatDateForApi(UpperDate))

            axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                //console.log(res.data)
                for (var i in res.data) {
                    if(i < (Object.keys(res.data).length - 1)) {
                        chartLabels.push((res.data[i].month).slice(0, 3))
                        count.push(res.data[i].users)
                    }
                }

                const lastData = count[11]
                const lastMonthData = count[10]

                //console.log(lastData)
                //console.log(lastMonthData)
                setPresentMonthCount(lastData)

                setMomUsersPercentage(((lastData - lastMonthData) / lastMonthData) * 100)

                /*localStorage.setItem("months", JSON.stringify(chartLabels))
                localStorage.setItem("activatedUsersForLastOneYear", JSON.stringify(count))
*/
                setDataCount(count)
                dataCount = count
                setOptions(chartLabels)
                options = chartLabels

                //getMonthlyRegisteredDevicesTrend()
                //getDevicesPerProduct()

                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                //console.log(error)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
            //setErrorMessage("You do not have permission to view this. Please contact admin.")
        }
    }

    useEffect( () => {
        getMonthlyRegisteredUsersTrend()
        /*setActivatedUsersCount(JSON.parse(localStorage.getItem("activatedUsersForLastOneYear")))
        activatedUsersCount = JSON.parse(localStorage.getItem("activatedUsersForLastOneYear"))

        //console.log(JSON.parse(sessionStorage.getItem("activatedUsersForLastOneYear")))

        setPresentMonthCount(activatedUsersCount[11])

        setMomUsersPercentage(((activatedUsersCount[11] - activatedUsersCount[10])/activatedUsersCount[10]) * 100)
*/
    }, [""])


    return (
        <Card extra="!p-[20px] text-center">
            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                    Registered Users Trend
                </h2>
            </div>

            <div
                className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
                <div className="flex flex-col">
                    <p className="mt-[20px] text-3xl font-bold text-navy-700 dark:text-white">
                        {presentMonthCount}
                    </p>
                    <div className="flex flex-col items-start">
                        <p className="mt-2 text-left text-sm text-gray-600">{reportingPeriod.monthName}<br/>complete month</p>
                        <div className="flex flex-row items-center justify-center">
                            {momUsersPercentage >= 0 ?
                                <div className="flex flex-row items-center justify-center">
                                    <MdArrowDropUp className="font-medium text-green-500"/>
                                    <p className="text-sm font-bold text-green-500"> {momUsersPercentage.toFixed(0).replace("-", "")} % </p>
                                </div> :
                                <div className="flex flex-row items-center justify-center">
                                    <MdArrowDropDown className="font-medium text-red-500"/>
                                    <p className="text-sm font-bold text-red-500"> {momUsersPercentage.toFixed(0).replace("-", "")} % </p>
                                </div>
                            }

                        </div>
                    </div>
                </div>
                <div className="h-full w-full">
                    <LineChart
                        options={{
                            legend: {
                                show: false,
                            },

                            theme: {
                                mode: "light",
                            },
                            chart: {
                                type: "line",

                                toolbar: {
                                    show: true,
                                },
                            },

                            dataLabels: {
                                enabled: false,
                            },
                            stroke: {
                            },

                            tooltip: {
                                style: {
                                    fontSize: "12px",
                                    fontFamily: undefined,
                                    backgroundColor: "#000000"
                                },
                                theme: 'dark',
                                x: {
                                },
                            },
                            grid: {
                                show: false,
                            },
                            xaxis: {
                                categories: options,
                                show: true,
                                axisBorder: {
                                    show: true,
                                },
                                axisTicks: {
                                    show: true,
                                },
                                labels: {
                                    style: {
                                        colors: "#A3AED0",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                    },
                                },
                                type: "text",
                                range: undefined,
                            },

                            yaxis: {
                                show: true,
                                color: "black",
                                labels: {
                                    show: true,
                                    style: {
                                        colors: "#CBD5E0",
                                        fontSize: "14px",
                                    },
                                },
                            },
                        }}
                        series={[
                            {
                                name: "User Count",
                                data: dataCount,
                                color: "#0b83b5",
                            }
                        ]}
                    />
                </div>
            </div>
        </Card>
    );
};

export default RegisteredUsersGraph;
